import React, { useState, useEffect, useRef } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
// import CapacityAllocation from "../Pages/CapacityAllocation/CapacityAllocation";
import Menubar from "../Layout/Menubar/Menubar";
import TaskAssignment from "../Pages/TaskAssignment/TaskAssignment";
import TicketAssignment from "../Pages/TicketAssignment/TicketAssignment";
import Bubble from "../Layout/Bubble/Bubble";
import Homescreen from "../Pages/Homescreen/Homescreen";
import CalendarUI from "../Components/Calendar/CalendarUI";
import CustomerMaster from "../Pages/Master/Customer/CustomerMaster";
import CustomerMasterEdit from "../Pages/Master/Customer/CustomerMasterEdit";
import EmployeeMaster from "../Pages/Master/Employee/EmployeeMaster";
import EmployeeMasterEdit from "../Pages/Master/Employee/EmployeeMasterEdit";
import MilestoneMaster from "../Pages/Master/Milestone/MilestoneMaster";
import MilestoneMasterEdit from "../Pages/Master/Milestone/MilestoneMasterEdit";
import EngagementMaster from "../Pages/Master/EngagementMaster/EngagementMaster";
import EngagementMasterEdit from "../Pages/Master/EngagementMaster/EngagementMasterEdit";
import ApplicationMaster from "../Pages/Master/Application/ApplicationMaster";
import ApplicationMasterEdit from "../Pages/Master/Application/ApplicationMasterEdit";
import CostCenterMaster from "../Pages/Master/CostCenter/CostCenterMaster";
import CostCenterEdit from "../Pages/Master/CostCenter/CostCenterEdit";
//import CostCenterMasterEdit from "../Pages/Master/CostCenter/CostCenterMasterEdit";
import LeaveMaster from "../Pages/Master/Leave/LeaveMaster";
import LeaveMasterEdit from "../Pages/Master/Leave/LeaveMasterEdit";
// import RequestLeave from "../Pages/RequestLeave/RequestLeave";
import jwt_decode from "jwt-decode";
// import { Dashboard } from "@mui/icons-material";
import Protected from "../Helpers/Protected";
import AccessDenied from "../Pages/Access Denied/AccessDenied";
import PhaseMaster from "../Pages/Master/Phase/PhaseMaster";
import PhaseMasterEdit from "../Pages/Master/Phase/PhaseMasterEdit";
import WorkPolicyMaster from "../Pages/Master/WorkPolicy/WorkPolicyMaster";
import WorkPolicyMasterEdit from "../Pages/Master/WorkPolicy/WorkPolicyMasterEdit";
import CapacityAllocationAMC from "../Pages/CapacityAllocation/CapacityAllocationAMC";
import CapacityAllocationTNM from "../Pages/CapacityAllocation/CapacityAllocationTNM";
import CapacityAllocationPROJECT from "../Pages/CapacityAllocation/CapacityAllocationPROJECT";
import ManagerDashboard from "../Pages/ManagerDashboard/ManagerDashboard";
import TimeSheetPolicy from "../Pages/Master/TimeSheetPolicy/TimeSheetPolicy";
import TimeSheetPolicyEdit from "../Pages/Master/TimeSheetPolicy/TimeSheetPolicyEdit";
import CapacityUtilizationReport from "../Pages/Report/CapacityUtilizationReport/CapacityUtilizationReport";
import ResourceCapacity from "../Pages/Report/ResourceCapacity/ResourceCapacity";
import MilestoneReport from "../Pages/Report/MileStonReport/MilestoneReport";
import PeriodReport from "../Pages/Report/PeriodReport/PeriodReport";
import ManagementDashboardReport from "../Pages/Report/ManagerDashboard/ManagementDashboardReport";
import NewPeriodReport from "../Pages/Report/NewPeriodReport/NewPeriodReport";
import POPendingReport from "../Pages/Report/POPendingReport/POPendingReport";
import RequirementTraceability from "../Pages/Traceability Matrix/TraceabilityRequirements"; //Ankita
import RequirementTraceabilityEdit from "../Pages/Traceability Matrix/TraceabilityRequirementEdit"; //Ankita
import TraceabilityTestCases from "../Pages/Traceability Matrix/TraceabilityTestCases"; //Ankita
import TraceabilityTestCasesEdit from "../Pages/Traceability Matrix/TraceabilityTestCasesEdit"; //Ankita
import TestCaseIssueReport from "../Pages/Report/TestCaseIssueReport/TestCaseIssueReport";
import OrganizationChart from "../Pages/TeamStructure/OrganizationChart";
import AmcReport from "../Pages/Report/AmcReport/AmcReport";
import EngagementReport from "../Pages/Report/EngagementReport/EngagementReport";
import TraceabilityWorkPacketUpload from "../Pages/Traceability Matrix/TraceabilityWorkPacketUpload";
import TraceabilityEngagementStages from "../Pages/Engagement/Stages/TraceabilityEngagementStages";
import RequirementReport from "../Pages/Report/RequirementReport/RequirementReport";
import TraceabilityTestCaseIssue from "../Pages/Traceability Matrix/TraceabilityTestCaseIssue"; //sangam
import Enquiry from "../Pages/Engagement/Enquiry/Enquiry";
import EnquiryEdit from "../Pages/Engagement/Enquiry/EnquiryEdit";
import PurchaseOrderForm from "../Pages/Engagement/PurchaseOrderForm/PurchaseOrderForm";
import PurchaseOrderFormEdit from "../Pages/Engagement/PurchaseOrderForm/PurchaseOrderFormEdit";
import SelfRatingScreen from "../Pages/Rating/SelfRatingScreen";
import ManagerRatingScreen from "../Pages/Rating/ManagerRatingScreen";
import TeamLeadRatingScreen from "../Pages/Rating/TeamLeadRatingScreen";
import RatingComponent from "../Pages/Rating/RatingComponent";
import PowerBiReport from "../Pages/Report/PowerBiReport/PowerBiReportManagement";
import PowerBiReportHR from "../Pages/Report/PowerBiReport/PowerBiReportHR";
import PowerBiReportManagement from "../Pages/Report/PowerBiReport/PowerBiReportManagement";
import LoginPage from "../Pages/Login/Login";
import ForgetPassword from "../Pages/Login/ForgetPassword";
import ResetPasword from "../Pages/Login/ResetPasword";
import RiskMitigationEdit from "../Pages/Engagement/RiskMitigation/RiskMitigationEdit";
import RiskMitigation from "../Pages/Engagement/RiskMitigation/RiskMitigation";
import CompOffLeaveMaster from "../Pages/Master/CompOffLeave/CompOffLeaveMaster";
import CompOffLeaveMasterEdit from "../Pages/Master/CompOffLeave/CompOffLeaveMasterEdit";
import KRADashboard from "../Pages/Master/KRADetails/KRADashboard";
import KRAMaster from "../Pages/Master/KRADetails/KRAMaster";
import PowerBiReportProjectStagesHistory from "../Pages/Report/PowerBiReport/PowerBiReportProjectStagesHistory";
import PowerBiReportProjectStatus from "../Pages/Report/PowerBiReport/PowerBiReportProjectStatus";
import NewMenu from "../Layout/Menubar/NewMenu";

import { Button, Layout, Menu, Popconfirm, PopconfirmProps, theme, Tooltip } from "antd";
import { Link , useLocation } from "react-router-dom";
import {
  HomeOutlined,
  CalendarOutlined,
  AppstoreOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  TagsOutlined,
  UserOutlined,
  TeamOutlined,
  CrownOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  ExperimentOutlined,
  ContainerOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
  DeploymentUnitOutlined,
  CreditCardOutlined,
  FlagOutlined,
  AppstoreAddOutlined,
  UserAddOutlined,
  ProjectOutlined,
  ClockCircleOutlined,
  SolutionOutlined,
  FieldTimeOutlined,
  SettingOutlined,
  BarChartOutlined,
  StarOutlined,
} from "@ant-design/icons";
import { Content, Header } from "antd/es/layout/layout";
import { RiMenuUnfoldLine, RiMenuFoldLine } from "react-icons/ri";
import { FaPowerOff } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";
import { FaRegStar } from "react-icons/fa";
import { PiTreeStructure } from "react-icons/pi";
import { AiOutlineInteraction } from "react-icons/ai";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { MdHelpOutline } from "react-icons/md";
import { MdOutlinePolicy } from "react-icons/md";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import ProtectedMenu from "../Helpers/ProtectedMenu";
import bigLogo from "../assets/wow-logo.png";
import profileImage from "../assets/default-user.png";
import "./Routes.css";
import Productivity from "../Pages/Rating/Productivity/Productivity";
import ProductivityCreate from "../Pages/Rating/Productivity/ProductivityCreate";
import axios from "axios";
 

const { Sider } = Layout;
export const ApplicationContext = React.createContext({});

const Router = () => {
  let navigate = useNavigate();
  const [asidebar, setAsidebar] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [context, setContext] = useState<any>({});
  const [cookie, setCookie] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  //const context = getContext();
  const { instance, accounts } = useMsal();
  const RoleIdArray = context?.RoleId?.split(",");
  const empName = context?.UserName ? context?.UserName : "Name";
  const empId = context?.EmployeeId;

  const [envteam, setEnvteam] = useState<any>( 
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
    // process.env.REACT_APP_Login_PATH ? process.env.REACT_APP_Login_PATH : ""
  );

  const [env, setEnv] = useState<any>(
    process.env.REACT_APP_PUBLISH_PATH ? process.env.REACT_APP_PUBLISH_PATH : ""
  );
  var decoded;

  const prod = {
    url: process.env.REACT_APP_Login_PATH,
  };
  const dev = {
    url: "",
  };

  const { url } = process.env.NODE_ENV === "development" ? dev : prod;

  useEffect(() => {
    var token = getCookie("ApplicationToken");

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    }
    if (token != undefined) {
      decoded = jwt_decode(token);

      if (decoded.IsFirstLogin === "True") {
        navigate(`/resetPassword/${decoded.UID}`);
      }
      setCookie(true); 
      setContext(decoded);
    }
  }, []);

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken(); 


  // LOGOUT FUNCTIONALITY
  // const handleLogout = async () => {
  //   debugger;
  //   try {
  //     //console.log('inside handle')
  //    // if (accounts[0]) {   ]
  //    await axios.post(`${url}/Login/Logout`,
  //     {}, { withCredentials: true }
  //   );

  //   //clear client-side storage
  //   localStorage.clear();
  //   sessionStorage.clear();
    
  //   // deleteAllcookies();
  //   //Perform Azure AD Logout
  //    // Call MSAL logout
  //    if (accounts[0]){
  //     //deleteCookie("ApplicationToken");
  //     instance.logoutRedirect();
  //    }

  //   navigate(`${url}/Login/Login`);
    
  //     //}
  //   } catch (e) {
  //     console.error("Logout failed:", e);
  //   }
  // };

  
  // const deleteCookie = (name) => {  
  //   document.cookie = 
  //     name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  // }; 

  // const deleteAllcookies = () =>
  //   {
  //     const cookies = document.cookie.split(';');
  
  //     cookies.forEach(cookie => {
  //       const [name] = cookie.split('=');
  //       deleteCookie(name.trim());
  //     });
  //   };

  //Menu Array
  const items = [
    {
      key: "dashboard",
      label: (
        <ProtectedMenu permittedPages={"Dashboard"}>
          <Link
            to={`${env}/Dashboard`}
           // onClick={() => console.log("dashboard click")}
          >
            Dashboard
          </Link>
        </ProtectedMenu>
      ),
      icon: <HomeOutlined />,
      condition: true,
    },
    {
      key: "calendar",
      label: (
        <ProtectedMenu permittedPages={"CalendarUI"}>
          <Link to="/calendar" //onClick={() => console.log("calendar click")}
          >
            Calendar
          </Link>
        </ProtectedMenu>
      ),
      icon: <CalendarOutlined />,
      condition: true,
    },
    {
      key: "daily-update",
      label: "Daily Update",
      icon: <GrTransaction />,
      condition: true,
      children: [
        {
          key: "leave",
          label: (
            <ProtectedMenu permittedPages={"LeaveMaster"}>
              <Link
                to={`${env}/master/leaveRequest`}
                //onClick={() => console.log("leave click")}
              >
                Leave
              </Link>
            </ProtectedMenu>
          ),
          icon: <FileTextOutlined />,
          condition: true,
        },
        {
          key: "tasks",
          label: (
            <ProtectedMenu permittedPages={"TaskAssignment"}>
              <Link
                to={`${env}/TaskDashboard`}
                state={"true"}
                //onClick={() => console.log("tasks click")}
              >
                Tasks
              </Link>
            </ProtectedMenu>
          ),
          icon: <CheckCircleOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8") || RoleIdArray?.includes("2") || RoleIdArray?.includes("1"),
        },
        {
          key: "tickets",
          label: (
            <ProtectedMenu permittedPages={"TicketAssignment"}>
              <Link
                to={`${env}/TicketDashboard`}
                state={"false"}
                //onClick={() => console.log("tickets click")}
              >
                Tickets
              </Link>
            </ProtectedMenu>
          ),
          icon: <TagsOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8") || RoleIdArray?.includes("2") || RoleIdArray?.includes("1"),
        },
        {
          key: "compOff",
          label: (
            <ProtectedMenu permittedPages={"CompOffLeaveMaster"}>
              <Link
                to={`${env}/master/CompOffLeaveRequest`}
                //onClick={() => console.log("tickets click")}
              >
                Comp-Off
              </Link>
            </ProtectedMenu>
          ),
          icon: <TagsOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8"),
        },
      ].filter((item) => item.condition),
    },
    {
      key: "rating",
      label: "Performance",
      icon: <FaRegStar />,
      condition: true,
      children: [
        {
          key: "selfRating",
          label: (
            <ProtectedMenu permittedPages={"SelfRating"}>
              <Link
                to={`${env}/rating/selfrating`}
                //onClick={() => console.log("self rating click")}
              >
                Self Rating
              </Link>
            </ProtectedMenu>
          ),
          icon: <UserOutlined />,
          condition: true,
        },
        {
          key: "teamLeadRating",
          label: (
            <ProtectedMenu permittedPages={"TeamleadRating"}>
              <Link
                to={`${env}/rating/teamleadrating`}
               // onClick={() => console.log("team lead rating click")}
              >
                Team Lead Rating
              </Link>
            </ProtectedMenu>
          ),
          icon: <TeamOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8") || RoleIdArray?.includes("2"),
        },
        {
          key: "managerRating",
          label: (
            <ProtectedMenu permittedPages={"ManagerRating"}>
              <Link
                to={`${env}/rating/managerrating`}
                //onClick={() => console.log("team lead rating click")}
              >
                Manager Rating
              </Link>
            </ProtectedMenu>
          ),
          icon: <TeamOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8"),
        },
        {
          key: "kraRating",
          label: (
            <ProtectedMenu permittedPages={"KRADashboard"}>
              <Link
                to={`${env}/rating/kraRating`}
                //onClick={() => console.log("team lead rating click")}
              >
                KRA
              </Link>
            </ProtectedMenu>
          ),
          icon: <StarOutlined  />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8") || RoleIdArray?.includes("4"),
        },
        {
          key: "productivity",
          label: (
            <ProtectedMenu permittedPages={"Productivity"}>
              <Link
                to={`${env}/rating/productivity`}
                //onClick={() => console.log("team lead rating click")}
              >
                Productivity
              </Link>
            </ProtectedMenu>
          ),
          icon: <BarChartOutlined />,
          condition:RoleIdArray?.includes("3") || RoleIdArray?.includes("8"),
        },

      ].filter((item) => item.condition),
    },
    {
      key: "traceabilityMatrix",
      label: "Traceability Matrix",
      icon: <PiTreeStructure />,
      condition:
        RoleIdArray?.includes("3") ||
        RoleIdArray?.includes("8") ||
        RoleIdArray?.includes("10") ||
        RoleIdArray?.includes("2"),
      children: [
        {
          key: "requirements",
          label: (
            <ProtectedMenu permittedPages={"TraceabilityRequirements"}>
              <Link
                to={`${env}/TraceabilityMatrix/TraceabilityRequirements`}
                //onClick={() => console.log("requirements click")}
              >
                Requirements
              </Link>
            </ProtectedMenu>
          ),
          icon: <FileSearchOutlined />,
          condition: RoleIdArray?.includes("3") ||
                    RoleIdArray?.includes("8") ||
                    RoleIdArray?.includes("10") ||
                    RoleIdArray?.includes("2"), //permittedPages?.includes("TraceabilityRequirements"),
        },
        {
          key: "testCases",
          label: (
            <ProtectedMenu permittedPages={"TraceabilityTestCases"}>
              <Link
                to={`${env}/TraceabilityMatrix/TraceabilityTestCases`}
                //onClick={() => console.log("test cases click")}
              >
                Test Cases
              </Link>
            </ProtectedMenu>
          ),
          icon: <ExperimentOutlined />,
          condition: RoleIdArray?.includes("3") ||
                    RoleIdArray?.includes("8")  ||
                    RoleIdArray?.includes("10") ||
                    RoleIdArray?.includes("2"), //permittedPages?.includes("TraceabilityTestCases"),
        },
        {
          key: "workPacket",
          label: (
            <ProtectedMenu permittedPages={"TraceabilityWorkPacketUpload"}>
              <Link
                to={`${env}/TraceabilityMatrix/TraceabilityWorkPacketUpload`}
               // onClick={() => console.log("work packet click")}
              >
                Work Packet
              </Link>
            </ProtectedMenu>
          ),
          icon: <ContainerOutlined />,
          condition: RoleIdArray?.includes("3") ||
                    RoleIdArray?.includes("8")  ||
                    RoleIdArray?.includes("10") ||
                    RoleIdArray?.includes("2"), //permittedPages?.includes("TraceabilityWorkPacketUpload"),
        },
        {
          key: "issueUpload",
          label: (
            <ProtectedMenu permittedPages={"TraceabilityTestCasesIssue"}>
              <Link
                to={`${env}/TraceabilityMatrix/TraceabilityTestCaseIssue`}
               // onClick={() => console.log("issue upload click")}
              >
                Feedback
              </Link>
            </ProtectedMenu>
          ),
          icon: <ExclamationCircleOutlined />,
          condition: RoleIdArray?.includes("3") ||
                    RoleIdArray?.includes("8")  ||
                    RoleIdArray?.includes("10") ||
                    RoleIdArray?.includes("2"), //permittedPages?.includes("TraceabilityTestCasesIssue"),
        },
      ].filter((item) => item.condition),
    },
    {
      key: "engagements",
      label: "Engagements",
      icon: <AiOutlineInteraction />,
      condition:
        RoleIdArray?.includes("3") ||
        RoleIdArray?.includes("8") ||
        RoleIdArray?.includes("7") ||
        RoleIdArray?.includes("10") ||
        RoleIdArray?.includes("9") ||
        RoleIdArray?.includes("2"),
      children: [
        {
          key: "enquiry",
          label: (
            <ProtectedMenu permittedPages={"TraceabilityEngagementStages"}>
              <Link
                to={`${env}/Engagement/enquiry`}
               // onClick={() => console.log("enquiry click")}
              >
                Enquiry
              </Link>
            </ProtectedMenu>
          ),
          icon: <QuestionCircleOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8") || RoleIdArray?.includes("10") || RoleIdArray?.includes("9") || RoleIdArray?.includes("2"), 
        },
        {
          key: "stage",
          label: (
            <ProtectedMenu permittedPages={"TraceabilityEngagementStages"}>
              <Link
                to={`${env}/TraceabilityMatrix/TraceabilityEngagementStages`}
                //onClick={() => console.log("stage click")}
              >
                Stage Update
              </Link>
            </ProtectedMenu>
          ),
          icon: <DeploymentUnitOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8") || RoleIdArray?.includes("10") || RoleIdArray?.includes("9") || RoleIdArray?.includes("2"), 
        },
        {
          key: "purchaseOrder",
          label: (
            <ProtectedMenu permittedPages={"PurchaseOrderForm"}>
              <Link
                to={`${env}/Engagement/purchaseOrderForm`}
                //onClick={() => console.log("purchase order click")}
              >
                Purchase Order
              </Link>
            </ProtectedMenu>
          ),
          icon: <CreditCardOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("7") || RoleIdArray?.includes("10") || RoleIdArray?.includes("9") || RoleIdArray?.includes("2"),
        },
        {
          key: "riskMapping",
          label: (
            <ProtectedMenu permittedPages={"RiskMitigation"}>
              <Link
                to={`${env}/Engagement/RiskMitigation`}
                //onClick={() => console.log("risk mapping click")}
              >
                Risk Mapping
              </Link>
            </ProtectedMenu>
          ),
          icon: <FlagOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8") || RoleIdArray?.includes("10") || RoleIdArray?.includes("2"),
        },
        {
          key: "customerMaster",
          label: (
            <ProtectedMenu permittedPages={"CustomerMaster"}>
              <Link
                to={`${env}/master/customer`}
               // onClick={() => console.log("customer master click")}
              >
                Customer
              </Link>
            </ProtectedMenu>
          ),
          icon: <TeamOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("9") || RoleIdArray?.includes("10"), 
        },
        {
          key: "engagementMaster",
          label: (
            <ProtectedMenu permittedPages={"EngagementMaster"}>
              <Link
                to={`${env}/master/engagement`}
               // onClick={() => console.log("engagement master click")}
              >
                Engagement Master
              </Link>
            </ProtectedMenu>
          ),
          icon: <ProjectOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("9") || RoleIdArray?.includes("10"),
        },
        {
          key: "applicationMaster",
          label: (
            <ProtectedMenu permittedPages={"ApplicationMaster"}>
              <Link
                to={`${env}/master/application`}
               // onClick={() => console.log("application master click")}
              >
                Application 
              </Link>
            </ProtectedMenu>
          ),
          icon: <AppstoreAddOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("9") || RoleIdArray?.includes("10"),
        },
        {
          key: "phaseMaster",
          label: (
            <ProtectedMenu permittedPages={"PhaseMaster"}>
              <Link
                to={`${env}/master/phase`}
               // onClick={() => console.log("phase master click")}
              >
                Phase 
              </Link>
            </ProtectedMenu>
          ),
          icon: <ProjectOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("9") || RoleIdArray?.includes("10"), //permittedPages?.includes("PhaseMaster"),
        },
      ].filter((item) => item.condition),
    },
    {
      key: "master",
      label: "Master",
      icon: <AppstoreOutlined />,
      condition:
        RoleIdArray?.includes("6") ||
        RoleIdArray?.includes("4"),
      children: [
        {
          key: "employeeMaster",
          label: (
            <ProtectedMenu permittedPages={"EmployeeMaster"}>
              <Link
                to={`${env}/master/employee`}
               // onClick={() => console.log("employee master click")}
              >
                Employee Master
              </Link>
            </ProtectedMenu>
          ),
          icon: <UserAddOutlined />,
          condition: RoleIdArray?.includes("6") ||
          RoleIdArray?.includes("4"), 
        },
        {
          key: "timesheetMaster",
          label: (
            <ProtectedMenu permittedPages={"TimesheetMaster"}>
              <Link
                to={`${env}/master/timesheet`}
               // onClick={() => console.log("timesheet master click")}
              >
                Timesheet Master
              </Link>
            </ProtectedMenu>
          ),
          icon: <ClockCircleOutlined />,
          condition: RoleIdArray?.includes("6") ||
          RoleIdArray?.includes("4"), 
        },
        {
          key: "verticalMaster",
          label: (
            <ProtectedMenu permittedPages={"CostCenterMaster"}>
              <Link
                to={`${env}/master/costcenter`}
               // onClick={() => console.log("vertical master click")}
              >
                Vertical Master
              </Link>
            </ProtectedMenu>
          ),
          icon: <DeploymentUnitOutlined />,
          condition: RoleIdArray?.includes("6") ||
          RoleIdArray?.includes("4"),
        },
        {
          key: "workpolicyMaster",
          label: (
            <ProtectedMenu permittedPages={"WorkPolicyMaster"}>
              <Link
                to={`${env}/master/workpolicy`}
               // onClick={() => console.log("work policy click")}
              >
                Work Policy Master
              </Link>
            </ProtectedMenu>
          ),
          icon: <SolutionOutlined />,
          condition: RoleIdArray?.includes("6") ||
          RoleIdArray?.includes("4"), 
        },
      ].filter((item) => item.condition),
    },
    {
      key: "planning",
      label: "Planning",
      icon: <CalendarOutlined />,
      condition:
        //RoleIdArray?.includes("2") ||
        RoleIdArray?.includes("3") ||
        RoleIdArray?.includes("8") ||
        RoleIdArray?.includes("10") ||
        RoleIdArray?.includes("7") ||
        RoleIdArray?.includes("6"),
      children: [
        // Milestone Master
        {
          key: "milestones",
          label: (
            <ProtectedMenu permittedPages={"MilestoneMaster"}>
              <Link
                to={`${env}/master/milestone`}
               // onClick={() => console.log("Milestones click")}
              >
                Milestones
              </Link>
            </ProtectedMenu>
          ),
          icon: <FieldTimeOutlined />,
          condition:
            RoleIdArray?.includes("3") ||
            RoleIdArray?.includes("7"),
        },
        // Capacity Allocation SubMenu
        {
          key: "capacityAllocation",
          label: "Capacity Allocation",
          icon: <SettingOutlined />,
          condition:
            //RoleIdArray?.includes("2") ||
            RoleIdArray?.includes("3") ||
            RoleIdArray?.includes("8") ||
            RoleIdArray?.includes("10"),
          children: [
            {
              key: "amc",
              label: (
                //<ProtectedMenu permittedPages={"CapacityAllocation"}>
                <Link
                  to={`${env}/CapacityAllocation/AMC`}
                 // onClick={() => console.log("AMC click")}
                >
                  AMC
                </Link>
                //</ProtectedMenu>
              ),
              icon: <DeploymentUnitOutlined />,
              condition: RoleIdArray?.includes("3") ||
              RoleIdArray?.includes("8") ||
              RoleIdArray?.includes("10"), //permittedPages?.includes("CapacityAllocation"),
            },
            {
              key: "project",
              label: (
                //<ProtectedMenu permittedPages={"CapacityAllocation"}>
                <Link
                  to={`${env}/CapacityAllocation/PROJECT`}
                 // onClick={() => console.log("Project click")}
                >
                  Project
                </Link>
                //</ProtectedMenu>
              ),
              icon: <ProjectOutlined />,
              condition: RoleIdArray?.includes("3") ||
              RoleIdArray?.includes("8") ||
              RoleIdArray?.includes("10"), //permittedPages?.includes("CapacityAllocation"),
            },
            {
              key: "tnm",
              label: (
                //<ProtectedMenu permittedPages={"CapacityAllocation"}>
                <Link
                  to={`${env}/CapacityAllocation/TNM`}
                 // onClick={() => console.log("T&M click")}
                >
                  T&M
                </Link>
                //</ProtectedMenu>
              ),
              icon: <DeploymentUnitOutlined />,
              condition: RoleIdArray?.includes("3") ||
              RoleIdArray?.includes("8") ||
              RoleIdArray?.includes("10"), //permittedPages?.includes("CapacityAllocation"),
            },
          ].filter((item) => item.condition),
        },
      ].filter((item) => item.condition),
    },
    {
      key: "reports",
      label: "Reports",
      icon: <HiOutlineDocumentReport />,
      condition: true,
      children: [
        // Management Power Bi Report
        {
          key: "managementPowerBi",
          label: (
            <ProtectedMenu permittedPages={"PowerBiReport"}>
              <Link
                to={`${env}/report/powerbireport/management`}
               // onClick={() => console.log("enquiry click")}
              >
                Management Power Bi Report
              </Link>
            </ProtectedMenu>
          ),
          icon: <AppstoreAddOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("10") || RoleIdArray?.includes("9") || RoleIdArray?.includes("7"),
        },
        // HR Power Bi Report
        {
          key: "hrPowerBi",
          label: (
            <ProtectedMenu permittedPages={"PowerBiReport"}>
              <Link
                to={`${env}/report/powerbireport/hr`}
               // onClick={() => console.log("stage click")}
              >
                HR Power Bi Report
              </Link>
            </ProtectedMenu>
          ),
          icon: <TeamOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("4"),
        },
        // Project Stage History
        {
          key: "projectStageHistoryPowerBi",
          label: (
            <ProtectedMenu permittedPages={"PowerBiReport"}>
              <Link
                to={`${env}/report/powerbireport/projectstagehistory`}
               // onClick={() => console.log("purchase order click")}
              >
                Project Stage History
              </Link>
            </ProtectedMenu>
          ),
          icon: <UserAddOutlined />,
          condition:
            RoleIdArray?.includes("3") ||
            RoleIdArray?.includes("8") ||
            RoleIdArray?.includes("2") ||
            RoleIdArray?.includes("10"),
        },
        // Project Status
        {
          key: "projectStatusPowerBi",
          label: (
            <ProtectedMenu permittedPages={"PowerBiReport"}>
              <Link
                to={`${env}/report/powerbireport/projectstatus`}
               // onClick={() => console.log("risk mapping click")}
              >
                Project Status
              </Link>
            </ProtectedMenu>
          ),
          icon: <ProjectOutlined />,
          condition: RoleIdArray?.includes("3") ||
                    RoleIdArray?.includes("8") ||
                    RoleIdArray?.includes("2") ||
                    RoleIdArray?.includes("10"),
        },
        // Management Dashboard
        {
          key: "managementDashboard",
          label: (
            <ProtectedMenu permittedPages={"ManagementDashboardReport"}>
              <Link
                to={`${env}/report/managementdashboard`}
               // onClick={() => console.log("phase master click")}
              >
                Management Dashboard
              </Link>
            </ProtectedMenu>
          ),
          icon: <ProjectOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8"),
        },
        // PO Pending
        {
          key: "poPending",
          label: (
            <ProtectedMenu permittedPages={"POPendingReport"}>
              <Link
                to={`${env}/report/popending`}
               // onClick={() => console.log("timesheet master click")}
              >
                PO Pending
              </Link>
            </ProtectedMenu>
          ),
          icon: <ClockCircleOutlined />,
          condition: RoleIdArray?.includes("3") || RoleIdArray?.includes("8") || RoleIdArray?.includes("7"),
          //protected: "POPendingReport",
        },
        // Milestone Report
        {
          key: "milestoneReport",
          label: (
            //<ProtectedMenu permittedPages={"MileStoneReport"}>
            <Link
              to={`${env}/report/milestone`}
             // onClick={() => console.log("vertical master click")}
            >
              Milestone
            </Link>
            //</ProtectedMenu>
          ),
          icon: <DeploymentUnitOutlined />,
          condition:
            RoleIdArray?.includes("3") ||
            RoleIdArray?.includes("7"),
        },
        // Capacity Utilization
        {
          key: "capacityUtilizationReport",
          label: (
            //<ProtectedMenu permittedPages={"CapacityUtilizationReport"}>
            <Link
              to={`${env}/report/capacityutilization`}
             // onClick={() => console.log("work policy click")}
            >
              Capacity Utilization
            </Link>
            //</ProtectedMenu>
          ),
          icon: <SolutionOutlined />,
          condition:
            RoleIdArray?.includes("3") ||
            RoleIdArray?.includes("8") ||
            RoleIdArray?.includes("10"),
          //protected: "CapacityUtilizationReport",
        },
        // Resource Capacity
        {
          key: "resourceCapacity",
          label: (
            //<ProtectedMenu permittedPages={"ResourceCapacityReport"}>
            <Link
              to={`${env}/report/resourcecapactiy`}
             // onClick={() => console.log("work policy click")}
            >
              Resource Capacity
            </Link>
            //</ProtectedMenu>
          ),
          icon: <SolutionOutlined />,
          condition: RoleIdArray?.includes("3") ||
                    RoleIdArray?.includes("8") ||
                    RoleIdArray?.includes("10"),
        },
        // Summary Period
        {
          key: "summaryPeriod",
          label: (
            //<ProtectedMenu permittedPages={"NewPeriodReport"}>
            <Link
              to={`${env}/report/newperiod`}
              //onClick={() => console.log("work policy click")}
            >
              Summary Period
            </Link>
            //</ProtectedMenu>
          ),
          icon: <SolutionOutlined />,
          condition: true,
          //protected: "NewPeriodReport",
        },
        // Detail Period
        {
          key: "detailPeriod",
          label: (
            //<ProtectedMenu permittedPages={"PeriodReport"}>
            <Link
              to={`${env}/report/period`}
             // onClick={() => console.log("work policy click")}
            >
              Detail Period
            </Link>
            //</ProtectedMenu>
          ),
          icon: <SolutionOutlined />,
          condition: true,
          //protected: "PeriodReport",
        },
        // Testcase Issue
        {
          key: "testcaseIssue",
          label: (
            //<ProtectedMenu permittedPages={"TestCaseIssueReport"}>
            <Link
              to={`${env}/report/testCaseIssue`}
             //  onClick={() => console.log("work policy click")}
            >
              Testcase Issue
            </Link>
            //</ProtectedMenu>
          ),
          icon: <SolutionOutlined />,
          condition: true,
          //protected: "TestCaseIssueReport",
        },
        // AMC Report
        {
          key: "amcReport",
          label: (
            <ProtectedMenu permittedPages={"AmcReport"}>
              <Link
                to={`${env}/report/amcReport`}
               // onClick={() => console.log("work policy click")}
              >
                AMC Report
              </Link>
            </ProtectedMenu>
          ),
          icon: <SolutionOutlined />,
          condition: true,
        },
        // Requirement Report
        {
          key: "requirementReport",
          label: (
            <ProtectedMenu permittedPages={"RequirementReport"}>
              <Link
                to={`${env}/report/requirementReport`}
               // onClick={() => console.log("work policy click")}
              >
                Requirement Report
              </Link>
            </ProtectedMenu>
          ),
          icon: <SolutionOutlined />,
          condition:
            RoleIdArray?.includes("3") ||
            RoleIdArray?.includes("8") ||
            RoleIdArray?.includes("10") ||
            RoleIdArray?.includes("2"),
          //protected: "RequirementReport",
        },
        // Engagement Report
        {
          key: "engagementReport",
          label: (
            <ProtectedMenu permittedPages={"EngagementReport"}>
              <Link
                to={`${env}/report/engagementReport`}
               // onClick={() => console.log("work policy click")}
              >
                Engagement Report
              </Link>
            </ProtectedMenu>
          ),
          icon: <SolutionOutlined />,
          condition:
            RoleIdArray?.includes("3") ||
            RoleIdArray?.includes("8") ||
            RoleIdArray?.includes("10") ||
            RoleIdArray?.includes("2"),
          // protected: "EngagementReport",
        },
      ].filter((item) => item.condition), //|| item.protected),
    },
    {
      key: "help",
      label: "Help",
      icon: <MdHelpOutline />,
      condition: true,
      children: [
        {
          key: "userManual",
          icon: <FieldTimeOutlined />,
          label: "User Manual",
          href: `${process.env.REACT_APP_Login_PATH}/assets/WoW_UserGuide.pptx`,
          download: "WoW_UserGuide.pptx",
          condition: true,
          onClick: () => {
            const link = document.createElement("a");
            link.href = `${process.env.REACT_APP_Login_PATH}/assets/WoW_UserGuide.pptx`;
            link.download = "WoW_UserGuide.pptx";
            link.click();
          },
        },
      ].filter((item) => item.condition),
    },
    {
      key: "policy",
      label: "Policy",
      icon: <MdOutlinePolicy />,
      condition: true,
      children: [
        {
          key: "leavePolicy",
          icon: <FieldTimeOutlined />,
          label: "Leave",
          href: `${process.env.REACT_APP_Login_PATH}/assets/LeavePolicy.pdf`,
          download: "LeavePolicy.pdf",
          condition: true,
          onClick: () => {
            const link = document.createElement("a");
            link.href = `${process.env.REACT_APP_Login_PATH}/assets/LeavePolicy.pdf`;
            link.download = "LeavePolicy.pdf";
            link.click();
          },
        },
        {
          key: "dressCode",
          icon: <FieldTimeOutlined />,
          label: "Dress Code",
          href: `${process.env.REACT_APP_Login_PATH}/assets/DressCodePolicy.pdf`,
          download: "DressCodePolicy.pdf",
          condition: true,
          onClick: () => {
            const link = document.createElement("a");
            link.href = `${process.env.REACT_APP_Login_PATH}/assets/DressCodePolicy.pdf`;
            link.download = "DressCodePolicy.pdf";
            link.click();
          },
        },
        {
          key: "poshPolicy",
          icon: <FieldTimeOutlined />,
          label: "Posh",
          href: `${process.env.REACT_APP_Login_PATH}/assets/PoshPolicy.pdf`,
          download: "PoshPolicy.pdf",
          condition: true,
          onClick: () => {
            const link = document.createElement("a");
            link.href = `${process.env.REACT_APP_Login_PATH}/assets/PoshPolicy.pdf`;
            link.download = "PoshPolicy.pdf";
            link.click();
          },
        },
      ].filter((item) => item.condition),
    },
  ].filter((item) => item.condition);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024); // Adjust for "lg" breakpoint
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const confirm: PopconfirmProps["onConfirm"] = (e) => {
  //    handleLogout(); 
  // };

  // const cancel: PopconfirmProps["onCancel"] = (e) => {
  //   e.preventDefault();
  // };

  // Close Sider when clicking outside
  const siderRef = useRef(null);
 
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (siderRef.current && !siderRef.current.contains(event.target)) {
        setCollapsed(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {cookie ? (
        <>
          <ApplicationContext.Provider value={context}>
            <Layout> 
              <Sider 
                collapsible
                collapsed={collapsed}
                breakpoint="lg"
                collapsedWidth={isMobile ? 0 : 60}
                width={250} // Full width when expanded
                // onCollapse={(value) => setCollapsed(value)}\
                trigger={null}
                style={{
                  height: "100vh",
                  position: "fixed",
                  left: 0,
                  top: 64,
                  zIndex: 999,
                }}
                ref={siderRef} 
              >
                <div className="scrollbar" id="custom-scroll">
                  <Menu mode="inline" items={items}></Menu> 
                </div>

                <div
                  className="side_bottom"
                  style={{
                    display: isMobile && collapsed ? "none" : "block",
                    // bottom: isMobile ? "64px" : "0px",
                  }}
                >
                  <div className="media">
                    <div className="media-left">
                      <img src={profileImage} alt="user profile icon" />
                    </div>
                    <div
                      className="media-body-inner"
                      style={{ display: collapsed ? "none" : "flex" }}
                    >
                      <div className="media-body">
                        <h3>{empName}</h3>
                        <a href={`${envteam}/TeamStructure/${empId}`}>
                          View Profile 
                        </a>
                      </div>
                      <div className="media-right">
                        
                        {/*<Popconfirm
                            title="Log Out"
                            description="Are you sure, you want to log out?"
                            onConfirm={confirm} 
                            onCancel={cancel} 
                            okText="Yes" 
                            cancelText="No" 
                          >
                            <span className="btn"> 
                              <FaPowerOff /> 
                            </span> 
                          </Popconfirm> */}

                      </div> 
                    </div>
                  </div>
                </div>
              </Sider>
              <Layout>
                <Header
                  style={{
                    padding: 0,
                    background: colorBgContainer,
                  }}
                >
                  <Button
                    type="text"
                    icon={collapsed ? <RiMenuUnfoldLine /> : <RiMenuFoldLine />}
                    onClick={() => setCollapsed(!collapsed)}
                    style={{
                      fontSize: "20px",
                      width: 64,
                      height: 64,
                    }}
                  />
                  <div className="wowlogo">
                    <img src={bigLogo} alt="WOW Logo" />
                  </div>
                </Header>
                <Content
                  className="main-content"
                  style={{ marginLeft: isMobile ? "16px" : "76px" }}
                >
                    
                    <Routes>
                      <Route
                        path={`${env}/Dashboard`}
                        element={
                          <Protected permittedPages={"Dashboard"}>
                            <Homescreen />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/TicketDashboard/TicketAssignment`}
                        element={
                          <Protected permittedPages={"TicketAssignment"}>
                            <TicketAssignment />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/TaskDashboard/TaskAssignment`}
                        element={
                          <Protected permittedPages={"TaskAssignment"}>
                            <TaskAssignment />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/CapacityAllocation/AMC`}
                        element={
                          <Protected permittedPages={"CapacityAllocation"}>
                            <CapacityAllocationAMC />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/CapacityAllocation/TNM`}
                        element={
                          <Protected permittedPages={"CapacityAllocation"}>
                            <CapacityAllocationTNM />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/CapacityAllocation/PROJECT`}
                        element={
                          <Protected permittedPages={"CapacityAllocation"}>
                            <CapacityAllocationPROJECT />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/calendar`}
                        element={
                          <Protected permittedPages={"CalendarUI"}>
                            <CalendarUI />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/customer`}
                        element={
                          <Protected permittedPages={"CustomerMaster"}>
                            <CustomerMaster />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/milestone`}
                        element={
                          <Protected permittedPages={"MilestoneMaster"}>
                            <MilestoneMaster />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/employee`}
                        element={
                          <Protected permittedPages={"EmployeeMaster"}>
                            <EmployeeMaster />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/customer/edit`}
                        element={
                          <Protected permittedPages={"CustomerMasterEdit"}>
                            <CustomerMasterEdit />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/milestone/edit`}
                        element={
                          <Protected permittedPages={"MilestoneMasterEdit"}>
                            <MilestoneMasterEdit />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/employee/edit`}
                        element={
                          <Protected permittedPages={"EmployeeMasterEdit"}>
                            <EmployeeMasterEdit />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/engagement`}
                        element={
                          <Protected permittedPages={"EngagementMaster"}>
                            <EngagementMaster />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/engagement/edit`}
                        element={
                          <Protected permittedPages={"EngagementMasterEdit"}>
                            <EngagementMasterEdit />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/leaveRequest`}
                        element={
                          <Protected permittedPages={"LeaveMaster"}>
                            <LeaveMaster />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/master/CompOffLeaveRequest`}
                        element={
                          <Protected permittedPages={"CompOffLeaveMaster"}>
                            <CompOffLeaveMaster />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/CompOffLeaveRequest/editC`}
                        element={
                          <Protected permittedPages={"CompOffLeaveMasterEdit"}>
                            <CompOffLeaveMasterEdit />
                          </Protected>
                        }
                      />

                      {/* <Route
                        path={`${env}/master/leaveRequest`}
                        element={<LeaveMaster />}
                      /> */}

                      <Route
                        path={`${env}/master/leaveRequest/edit`}
                        element={
                          <Protected permittedPages={"LeaveMasterEdit"}>
                            <LeaveMasterEdit />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/application`}
                        element={
                          <Protected permittedPages={"ApplicationMaster"}>
                            <ApplicationMaster />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/master/application/edit`}
                        element={
                          <Protected permittedPages={"ApplicationMasterEdit"}>
                            <ApplicationMasterEdit />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/master/phase`}
                        element={
                          <Protected permittedPages={"PhaseMaster"}>
                            <PhaseMaster />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/master/phase/edit`}
                        element={
                          <Protected permittedPages={"PhaseMasterEdit"}>
                            <PhaseMasterEdit />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/workpolicy`}
                        element={
                          <Protected permittedPages={"WorkPolicyMaster"}>
                            <WorkPolicyMaster />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/workpolicy/edit`}
                        element={
                          <Protected permittedPages={"WorkPolicyMasterEdit"}>
                            <WorkPolicyMasterEdit />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/costcenter`}
                        element={
                          <Protected permittedPages={"CostCenterMaster"}>
                            <CostCenterMaster />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/costcenter/edit`}
                        element={
                          <Protected permittedPages={"CostCenterMasterEdit"}>
                            <CostCenterEdit />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/timesheet`}
                        element={
                          <Protected permittedPages={"TimesheetMaster"}>
                            <TimeSheetPolicy />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/master/timesheet/edit`}
                        element={
                          <Protected permittedPages={"TimesheetMasterEdit"}>
                            <TimeSheetPolicyEdit />
                          </Protected>
                        }
                      />

                      {/* Reports */}
                      <Route
                        path={`${env}/report/capacityutilization`}
                        element={
                          <Protected permittedPages={"CapacityUtilizationReport"}>
                            <CapacityUtilizationReport />
                          </Protected>
                        }
                      />
                      {/* {Prashant power bi report} */}
                      <Route
                        path={`${env}/report/powerbireport/management`}
                        element={
                          <Protected permittedPages={"PowerBiReport"}>
                            <PowerBiReportManagement />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/report/powerbireport/hr`}
                        element={
                          <Protected permittedPages={"PowerBiReport"}>
                            <PowerBiReportHR />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/report/powerbireport/projectstagehistory`}
                        element={
                          <Protected permittedPages={"PowerBiReport"}>
                            <PowerBiReportProjectStagesHistory />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/report/powerbireport/projectstatus`}
                        element={
                          <Protected permittedPages={"PowerBiReport"}>
                            <PowerBiReportProjectStatus />
                          </Protected>
                        }
                      />

                      <Route
                        path="*"
                        element={<Navigate to={`${env}/calendar`} replace />}
                      />

                      <Route
                        path={`${env}/AccessDenied`}
                        element={<AccessDenied />}
                      />

                      {/* <Route
                        path="master/engagement"
                        element={<EngagementMaster />}
                      />
                      <Route
                        path="master/engagement/edit"
                        element={<EngagementMasterEdit />}
                      />*/}
                      <Route
                        path={`${env}/TaskDashboard`}
                        element={<ManagerDashboard />}
                      />
                      {/* Krishnam 06/03/2023 */}
                      <Route
                        path={`${env}/TicketDashboard`}
                        element={<ManagerDashboard />}
                      />

                      <Route
                        path={`${env}/TeamStructure/:id`}
                        element={
                          <Protected permittedPages={"TeamStructure"}>
                            <OrganizationChart />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/report/resourcecapactiy`}
                        element={
                          <Protected permittedPages={"ResourceCapacityReport"}>
                            <ResourceCapacity />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/report/milestone`}
                        element={
                          <Protected permittedPages={"MileStoneReport"}>
                            <MilestoneReport />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/report/period`}
                        element={
                          <Protected permittedPages={"PeriodReport"}>
                            <PeriodReport />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/report/popending`}
                        element={
                          <Protected permittedPages={"POPendingReport"}>
                            <POPendingReport />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/report/newperiod`}
                        element={
                          <Protected permittedPages={"NewPeriodReport"}>
                            <NewPeriodReport />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/report/managementdashboard`}
                        element={
                          <Protected permittedPages={"ManagementDashboardReport"}>
                            <ManagementDashboardReport />
                          </Protected>
                        }
                      />

                      {/*28-Feb-2024  sangam*/}
                      <Route
                        path={`${env}/report/testCaseIssue`}
                        element={
                          <Protected permittedPages={"TestCaseIssueReport"}>
                            <TestCaseIssueReport />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/report/amcReport`}
                        element={
                          <Protected permittedPages={"AmcReport"}>
                            <AmcReport />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/report/engagementReport`} //Krishnam 06-05-2024
                        element={
                          <Protected permittedPages={"EngagementReport"}>
                            <EngagementReport />
                          </Protected>
                        }
                      />
                      {/* Traceability Matrix Pages */}
                      <Route
                        path={`${env}/TraceabilityMatrix/TraceabilityRequirements`}
                        element={
                          //   <Protected permittedPages={"ManagementDashboardReport"}>
                          <RequirementTraceability />
                          //   </Protected>
                        }
                      />

                      <Route
                        path={`${env}/TraceabilityMatrix/TraceabilityRequirementEdit`}
                        element={
                          //   <Protected permittedPages={"ManagementDashboardReport"}>
                          <RequirementTraceabilityEdit />
                          //   </Protected>
                        }
                      />
                      <Route
                        path={`${env}/TraceabilityMatrix/TraceabilityTestCases`}
                        element={
                          //   <Protected permittedPages={"ManagementDashboardReport"}>
                          <TraceabilityTestCases />
                          //   </Protected>
                        }
                      />

                      <Route
                        path={`${env}/TraceabilityMatrix/TraceabilityTraceabilityTestCasesEdit`}
                        element={
                          //   <Protected permittedPages={"ManagementDashboardReport"}>
                          <TraceabilityTestCasesEdit />
                          //   </Protected>
                        }
                      />

                      <Route
                        path={`${env}/TraceabilityMatrix/TraceabilityWorkPacketUpload`}
                        element={<TraceabilityWorkPacketUpload />}
                      />

                      {/*sangam*/}
                      <Route
                        path={`${env}/TraceabilityMatrix/TraceabilityTestCaseIssue`}
                        element={<TraceabilityTestCaseIssue />}
                      />

                      {/*Prashant*/}
                      <Route
                        path={`${env}/TraceabilityMatrix/TraceabilityEngagementStages`}
                        element={<TraceabilityEngagementStages />}
                      />
                      {/*Prashant*/}
                      <Route
                        path={`${env}/report/requirementReport`}
                        element={
                          <Protected permittedPages={"RequirementReport"}>
                            <RequirementReport />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/Engagement/enquiry`}
                        element={
                          <Protected permittedPages={"Enquiry"}>
                            <Enquiry />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/Engagement/enquiry/edit`}
                        element={
                          <Protected permittedPages={"Enquiry"}>
                            <EnquiryEdit />
                          </Protected>
                        }
                      />

                      {/* sangam 12 july 2024 Rating routes */}
                      <Route
                        path={`${env}/rating/selfrating`}
                        element={<SelfRatingScreen />}
                      />

                      <Route
                        path={`${env}/rating/selfrating/edit`}
                        element={<RatingComponent type={"SELF"} />}
                      />

                      <Route
                        path={`${env}/rating/managerrating`}
                        element={<ManagerRatingScreen />}
                      />

                      <Route
                        path={`${env}/rating/managerrating/edit`}
                        element={<RatingComponent type={"MANAGER"} />}
                      />
                      <Route
                        path={`${env}/rating/teamleadrating`}
                        element={<TeamLeadRatingScreen />}
                      />

                      <Route
                        path={`${env}/rating/teamleadrating/edit`}
                        element={<RatingComponent type={"LEAD"} />}
                      />

                      <Route
                        path={`${env}/rating/kraRating`}
                        element={
                          <Protected permittedPages={"KRADashboard"}>
                            <KRADashboard />
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/rating/kraRating/Edit`}
                        element={
                          <Protected permittedPages={"KRAMaster"}>
                            <KRAMaster />
                          </Protected>
                        }
                      />
                      {/* Productitvity Prashant */}
                      <Route
                        path={`${env}/rating/productivity`}
                        element={
                          <Protected permittedPages={"Productivity"}>
                            <Productivity />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/rating/productivity/create`}
                        element={
                          <Protected permittedPages={"ProductivityCreate"}>
                            <ProductivityCreate />
                          </Protected>
                        }
                      />

                      {/* PO Form Prashant */}
                      <Route
                        path={`${env}/Engagement/purchaseOrderForm`}
                        element={
                          <Protected permittedPages={"PurchaseOrderForm"}>
                            <PurchaseOrderForm></PurchaseOrderForm>
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/Engagement/PurchaseOrderForm/PurchaseOrderFormEdit`}
                        element={
                          <Protected permittedPages={"PurchaseOrderFormEdit"}>
                            <PurchaseOrderFormEdit></PurchaseOrderFormEdit>
                          </Protected>
                        }
                      />
                      {/* Risk Mitigation-> Prashant 03-12-2024 */}
                      <Route
                        path={`${env}/Engagement/RiskMitigation`}
                        element={
                          <Protected permittedPages={"RiskMitigation"}>
                            <RiskMitigation></RiskMitigation>
                          </Protected>
                        }
                      />
                      <Route
                        path={`${env}/Engagement/RiskMitigation/RiskMitigationEdit`}
                        element={
                          <Protected permittedPages={"RiskMitigationEdit"}>
                            <RiskMitigationEdit />
                          </Protected>
                        }
                      />

                      <Route
                        path={`${env}/ChangePassword`}
                        element={<ResetPasword />}
                      />
                    </Routes>

                </Content>
              </Layout>
            </Layout>
          </ApplicationContext.Provider>
        </>
      ) : 
     ( 
        <>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/forgetPassword" element={<ForgetPassword />} />
            <Route path="/resetPassword/:id" element={<ResetPasword />} />
          </Routes>
        </>
       )}
    </>
  );
};

export default Router;
